import { useCallback } from 'react';

import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

type UsePageConflictAnalyticsProps = {
	source: string;
	actionSubjectId: string;
	contentId?: string;
	contentType?: string;
	collabService?: string;
	version?: number;
};

export const usePageConflictAnalytics = ({
	source,
	actionSubjectId,
	contentId,
	contentType,
	collabService,
	version,
}: UsePageConflictAnalyticsProps): {
	triggerPageConflictAnalytics: (errorMessage: any, extraData?: { [key: string]: any }) => void;
} => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const triggerPageConflictAnalytics = useCallback(
		(errorMessage: any, extraData: { [key: string]: any } = {}): void => {
			pageConflictAnalyticsEvent(
				source,
				actionSubjectId,
				{
					contentId,
					contentType,
					collabService,
					version,
					errorMessage,
					...extraData,
				},
				createAnalyticsEvent,
			);
		},
		[createAnalyticsEvent, source, actionSubjectId, contentId, contentType, collabService, version],
	);

	return { triggerPageConflictAnalytics };
};

export const pageConflictAnalyticsEvent = (
	source: string,
	actionSubjectId: string,
	attributes: any,
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
): void => {
	if (createAnalyticsEvent) {
		createAnalyticsEvent({
			type: 'sendTrackEvent',
			data: {
				source,
				action: 'error',
				actionSubject: 'pageConflict',
				actionSubjectId,
				attributes,
			},
		}).fire();
	}
};
